<template>
	<span :style="`${$attrs.column.style ? $attrs.column.style : ''} ${data['style']}`"
		  v-html="data[$attrs.column.key]"
		  class="content"
		  :title="`${data[$attrs.column.key]}${data['error'] != null ? '\nErrors:\n' + data['error'] : ''}`"></span>
</template>

<script>
	export default {
		name: 'HtmlColumn',
		props: {
			data: {
				type: Object,
				required: true
			}
		}
	}
</script>

<style scoped>
	.content {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
</style>